import React from 'react';
import { Box, ModuleHeader } from '@stitch-fix/mode-react';
import { useViewEvent } from '@stitch-fix/event-reporter';
import styles from './EmptyRecommendations.module.scss';
const EmptyRecommendations = ({
  categoryId
}: {
  categoryId: string;
}) => {
  const {
    ref,
    EventProvider
  } = useViewEvent({
    schema: 'category_view',
    name: 'empty_category_recommendations',
    category_id: categoryId
  });
  return <EventProvider>
      <Box className={styles.container} ref={ref}>
        <ModuleHeader header="These popular picks are unavailable" subheader="We'll try to restock with fresh selects soon, check back again later." />
      </Box>
    </EventProvider>;
};
export default EmptyRecommendations;